import { field, text } from "@nozbe/watermelondb/decorators";
import { BaseModel } from "./Base";

export default class Customer extends BaseModel {
  static table = "customers";
  @text("first_name") firstName: string;
  @text("last_name") lastName: string;
  @text("gender") gender: string | null;
  @text("email_address") emailAddress: string | null;
  @text("mobile_number") mobileNumber: string | null;
  @text("phone_number") phoneNumber: string | null;
  @field("loyalty_points") loyaltyPoints: number;
  @field("is_retailer_cus_account") isRetailerCusAccount: boolean;
  @field("is_trade_customer") isTradeCustomer: boolean;
  @field("retailer_id") retailerId: string | null;
}
